// extracted by mini-css-extract-plugin
export default {"rating":"Py-z","numberOfStars":"Qy-z","count":"Ry-z","barGraphSpacing":"Sy-z","barGraph":"Ty-z"};